var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFedex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x31_25-fedex"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M251.777,183.644v61.553h-0.36c-6.899-7.906-15.452-10.637-25.443-10.637    c-20.412,0-35.793,13.943-41.184,32.271c-12.937-42.694-70.006-41.4-87.615-10.063v-17.393H57.787v-18.831h43.125v-29.541H22.568    V323.54h35.219v-55.703h35.147c-1.079,4.097-1.653,8.483-1.653,13.081c0,52.542,73.744,65.692,93.58,17.034h-30.187    c-10.566,15.022-32.919,6.396-32.919-10.493h61.453c2.659,21.921,19.694,40.897,43.197,40.897    c10.134,0,19.407-4.959,25.084-13.371h0.359v8.555h44.717v-19.896v-30v-30v-40l0.002-20H251.777z M122.688,268.123    c4.386-18.902,29.973-18.398,33.423,0H122.688z M232.946,303.272c-24.869,0-24.438-45.139,0-45.139    C256.377,258.134,257.742,303.272,232.946,303.272z",
    style: {
      fill: "#442E8C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.345,323.332 296.156,323.332 296.156,183.661 375.848,183.661 375.848,208.995     328.787,208.995 328.787,237.432 375.345,237.432 375.345,261.004 328.283,261.004 328.283,298.503 375.345,298.503     375.345,323.332   ",
    style: {
      fill: "#F47624"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.393,298.585 411.496,323.333 379.537,323.333 417.789,280.382 379.537,237.429     412.84,237.429 435.154,262.01 456.631,237.429 488.928,237.429 450.844,280.215 489.432,323.333 455.456,323.333     433.393,298.585   ",
    style: {
      fill: "#F47624"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFedex);
export default __webpack_public_path__ + "static/media/fedex.85569164df002b5dd3f8e90653e7b0fd.svg";
export { ForwardRef as ReactComponent };